/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig {
    /**
     * куда можно перенаправить пользователей после авторизации
     * @type {Array<string>}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig
     */
    RedirectUriWhitelist?: Array<string> | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig {
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'RedirectUriWhitelist': json['RedirectUriWhitelist'] == null ? undefined : json['RedirectUriWhitelist'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'RedirectUriWhitelist': value['RedirectUriWhitelist'],
    };
}

